import React from 'react';
import { Box, Typography } from '@mui/material';
import { Inbox as InboxIcon } from '@mui/icons-material';

interface EmptyStateProps {
  message?: string;
  subMessage?: string;
}

/**
 * Универсальный компонент пустого состояния для таблиц и графиков.
 */
const EmptyState: React.FC<EmptyStateProps> = ({
  message = 'Нет данных',
  subMessage = 'Попробуйте изменить фильтры или выбрать другой период',
}) => (
  <Box sx={{
    display: 'flex', flexDirection: 'column', alignItems: 'center',
    py: 10, gap: 2, textAlign: 'center',
  }}>
    <Box sx={{
      width: 72, height: 72, borderRadius: '50%', bgcolor: 'action.hover',
      display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'text.secondary',
    }}>
      <InboxIcon sx={{ fontSize: 36 }} />
    </Box>
    <Typography variant="h6">{message}</Typography>
    <Typography variant="body2" color="text.secondary">{subMessage}</Typography>
  </Box>
);

export default EmptyState;
